<template>
    <div class="editor-container">

        <slot name="header"></slot>

        <div class="px-1">
            <AppEditableText :value="section.label" @update="onLabelUpdate" class="d-inline font-18">
                <div slot="popover-header" class="text-muted text-left">
                    Section name
                    <TeamLanguagePlaceholdersRef class="mb-1"/>
                </div>
                <template slot="popover-footer" slot-scope="{value}">
                    <div v-if="!value" class="text-danger text-left font-12">
                        Value is required
                    </div>
                </template>
            </AppEditableText>

            <AppConfirmationPopover
                class="float-right"
                message="Delete section?"
                :action="() => $emit('delete')">
                <div class="w-100 text-danger text-center clickable">
                    <i class="fal fa-trash-alt"></i>
                </div>
                <template slot="popover-content">
                    <div class="text-danger font-12">
                        This will also remove all the fields in the section.
                    </div>
                </template>
            </AppConfirmationPopover>
            <div class="text-muted">
                [{{ section.key }}]
            </div>
        </div>

        <div class="editor-section">
            <div class="custom-control custom-switch">
                <input class="custom-control-input"
                       type="checkbox"
                       :value="section.visible"
                       :checked="section.visible"
                       @change="updateProp('visible', !section.visible)"
                       id="visible">
                <label class="custom-control-label text-dark pt-1" for="visible">
                    Visible
                </label>
            </div>
            <div class="custom-control custom-switch">
                <input class="custom-control-input"
                       type="checkbox"
                       :value="section.editable"
                       :checked="section.editable"
                       @change="updateProp('editable', !section.editable)"
                       id="editable">
                <label class="custom-control-label text-dark pt-1" for="editable">
                    Editable
                </label>
            </div>
            <div class="custom-control custom-switch">
                <input class="custom-control-input"
                       type="checkbox"
                       :value="section.expandable"
                       :checked="section.expandable"
                       @change="updateProp('expandable', !section.expandable)"
                       id="expandable">
                <label class="custom-control-label text-dark pt-1" for="expandable">
                    Expandable
                </label>
            </div>
            <div v-if="section.expandable" class="custom-control custom-switch">
                <input class="custom-control-input"
                       type="checkbox"
                       :value="section.collapse"
                       :checked="section.collapse"
                       @change="updateProp('collapse', !section.collapse)"
                       id="collapse">
                <label class="custom-control-label text-dark pt-1" for="collapse">
                    Collapse
                </label>
            </div>
        </div>

        <slot name="editor-footer"></slot>
    </div>
</template>

<script>
import AppEditableText from '../../../../../../components/shared/AppEditableText'
import AppConfirmationPopover from '../../../../../../components/shared/AppConfirmationPopover'
import {FormSystemSections} from '@/types/document-viewer/section'
import TeamLanguagePlaceholdersRef from '@/views/settings/team/lang/TeamLanguagePlaceholdersRef'

export default {
    name: 'SectionEditor',
    components: {TeamLanguagePlaceholdersRef, AppConfirmationPopover, AppEditableText},
    props: {
        section: {
            type: Object,
            required: true
        },
        updateSection: {
            type: Function,
            required: true
        }
    },
    computed: {
        isLandedCostLines() {
            return this.section.key === FormSystemSections.LANDED_COST_LINES
        }
    },
    methods: {
        updateProp(path, value) {
            const section = _.cloneDeep(_.set(this.section, path, value))
            this.updateSection(section)
        },

        onLabelUpdate(value) {
            if (value) {
                this.updateProp('label', value)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "src/views/documents/subtypes/settings/editor/styles";
</style>
